const BaseModel = require("./base_model");
const APIConfig = require("apiconfig");

module.exports = BaseModel.extend({
  url: `${APIConfig.host}user/package`,
  isPro() {
    return this.get("has_ip");
  },
});
